(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.section-header');
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
this.headerBounds = {};

this.setHeaderHeight();

window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
};

this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

setHeaderHeight() {
document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

// 詳細検索パネル / ナビドロワーが開いている間はヘッダーを隠さない（開いているメニューが閉じてしまうのを防ぐ）
if (document.querySelector('.view_search.active') || document.querySelector('#seraNavDrawer.is-open')) return;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
this.header.classList.remove('scrolled-past-header');
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
// this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  /**
   * 複数の商品をカートに追加し、エラーハンドリングを行う関数
   * @param {Array} items - 追加する商品の配列 [{id: 123, quantity: 1}, ...]
   */
  async function addMultipleItemsToCart(items) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items }),
      });

      const data = await response.json();

      if (!response.ok) {
        const errorMessage = data.description || data.message || 'カートへの追加に失敗しました。';
        throw new Error(errorMessage);
      }

      console.log('カート追加成功:', data);

      // 例: カートドロワーを開く、またはカートページへ遷移
      // alert('カートに追加しました！'); // 必要に応じて削除
      window.location.href = '/cart';
    } catch (error) {
      console.error('エラー詳細:', error);

      let userMessage = '申し訳ありません。商品をカートに追加できませんでした。';

      if (error.message.includes('sold out') || error.message.includes('inventory')) {
        userMessage = '選択された商品の在庫が不足しているため、カートに追加できませんでした。';
      } else if (error.message.includes('valid')) {
        userMessage = '商品情報の取得に失敗しました。ページを更新して再度お試しください。';
      } else {
        userMessage += `\n(${error.message})`;
      }

      alert(`エラーが発生しました:\n${error.message}`);
    }
  }

  let addButton = document.querySelectorAll('.cart_add');
  if (addButton.length > 0) {
    addButton.forEach(function (ele) {
      ele.addEventListener('click', async function (e) {
        if (this.classList.contains('enable')) {
          const addItems = [];
          let inputs = this.closest('.card_body').querySelectorAll('input[data-id]');

          const test = await inputs.forEach(function (ele) {
            console.log(ele.dataset.id);
            console.log(ele.value);

            if (ele.value && ele.value > 0)
              addItems.push({
                id: ele.dataset.id,
                quantity: ele.value,
              });
          });
          if (addItems.length > 0) {
            addMultipleItemsToCart(addItems);
          }
        }
      });
    });
  }

  let count_inputs = document.querySelectorAll('input[name="count"]');
  if (count_inputs) {
    count_inputs.forEach(function (element) {
      element.addEventListener('input', async function (ele) {
        let add_button = this.closest('.card_body').querySelector('.cart_add');
        let inputs = this.closest('.card_body').querySelectorAll('input[data-id]');
        if (inputs) {
          let is_enable = false;
          await inputs.forEach(async function (e) {
            if (e.value && e.value > 0) is_enable = true;
          });
          if (is_enable) add_button.classList.add('enable');
          else add_button.classList.remove('enable');
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sera_collection_products"] && !Shopify.designMode) return;
  try {
    
  /**
   * 複数の商品をカートに追加し、エラーハンドリングを行う関数
   * @param {Array} items - 追加する商品の配列 [{id: 123, quantity: 1}, ...]
   */
  async function addMultipleItemsToCart(items) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items }),
      });

      const data = await response.json();

      if (!response.ok) {
        const errorMessage = data.description || data.message || 'カートへの追加に失敗しました。';
        throw new Error(errorMessage);
      }

      console.log('カート追加成功:', data);

      // 例: カートドロワーを開く、またはカートページへ遷移
      // alert('カートに追加しました！'); // 必要に応じて削除
      window.location.href = '/cart';
    } catch (error) {
      console.error('エラー詳細:', error);

      let userMessage = '申し訳ありません。商品をカートに追加できませんでした。';

      if (error.message.includes('sold out') || error.message.includes('inventory')) {
        userMessage = '選択された商品の在庫が不足しているため、カートに追加できませんでした。';
      } else if (error.message.includes('valid')) {
        userMessage = '商品情報の取得に失敗しました。ページを更新して再度お試しください。';
      } else {
        userMessage += `\n(${error.message})`;
      }

      alert(`エラーが発生しました:\n${error.message}`);
    }
  }

  let addButton = document.querySelectorAll('.cart_add');
  if (addButton.length > 0) {
    addButton.forEach(function (ele) {
      ele.addEventListener('click', async function (e) {
        if (this.classList.contains('enable')) {
          const addItems = [];
          let inputs = this.closest('.card_body').querySelectorAll('input[data-id]');

          const test = await inputs.forEach(function (ele) {
            console.log(ele.dataset.id);
            console.log(ele.value);

            if (ele.value && ele.value > 0)
              addItems.push({
                id: ele.dataset.id,
                quantity: ele.value,
              });
          });
          if (addItems.length > 0) {
            addMultipleItemsToCart(addItems);
          }
        }
      });
    });
  }

  let count_inputs = document.querySelectorAll('input[name="count"]');
  if (count_inputs) {
    count_inputs.forEach(function (element) {
      element.addEventListener('input', async function (ele) {
        let add_button = this.closest('.card_body').querySelector('.cart_add');
        let inputs = this.closest('.card_body').querySelectorAll('input[data-id]');
        if (inputs) {
          let is_enable = false;
          await inputs.forEach(async function (e) {
            if (e.value && e.value > 0) is_enable = true;
          });
          if (is_enable) add_button.classList.add('enable');
          else add_button.classList.remove('enable');
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sera_section"] && !Shopify.designMode) return;
  try {
    
  /**
   * 複数の商品をカートに追加し、エラーハンドリングを行う関数
   * @param {Array} items - 追加する商品の配列 [{id: 123, quantity: 1}, ...]
   */
  async function addMultipleItemsToCart(items) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items }),
      });

      const data = await response.json();

      if (!response.ok) {
        const errorMessage = data.description || data.message || 'カートへの追加に失敗しました。';
        throw new Error(errorMessage);
      }

      console.log('カート追加成功:', data);

      // 例: カートドロワーを開く、またはカートページへ遷移
      // alert('カートに追加しました！'); // 必要に応じて削除
      window.location.href = '/cart';
    } catch (error) {
      console.error('エラー詳細:', error);

      let userMessage = '申し訳ありません。商品をカートに追加できませんでした。';

      if (error.message.includes('sold out') || error.message.includes('inventory')) {
        userMessage = '選択された商品の在庫が不足しているため、カートに追加できませんでした。';
      } else if (error.message.includes('valid')) {
        userMessage = '商品情報の取得に失敗しました。ページを更新して再度お試しください。';
      } else {
        userMessage += `\n(${error.message})`;
      }

      alert(`エラーが発生しました:\n${error.message}`);
    }
  }

  let addButton = document.querySelectorAll('.cart_add');
  if (addButton.length > 0) {
    addButton.forEach(function (ele) {
      ele.addEventListener('click', async function (e) {
        // one_enable（単一バリアント商品）も enable と同様にカート追加を許可する
        if (this.classList.contains('enable') || this.classList.contains('one_enable')) {
          const addItems = [];
          let inputs = this.closest('.card_body').querySelectorAll('input[data-id]');

          const test = await inputs.forEach(function (ele) {
            console.log(ele.dataset.id);
            console.log(ele.value);

            if (ele.value && ele.value > 0)
              addItems.push({
                id: ele.dataset.id,
                quantity: ele.value,
              });
          });
          if (addItems.length > 0) {
            addMultipleItemsToCart(addItems);
          }
        }
      });
    });
  }

  let count_inputs = document.querySelectorAll('input[name="count"]');
  if (count_inputs) {
    count_inputs.forEach(function (element) {
      element.addEventListener('input', async function (ele) {
        let add_button = this.closest('.card_body').querySelector('.cart_add');
        let inputs = this.closest('.card_body').querySelectorAll('input[data-id]');
        if (inputs) {
          let is_enable = false;
          await inputs.forEach(async function (e) {
            if (e.value && e.value > 0) is_enable = true;
          });
          if (is_enable) add_button.classList.add('enable');
          else add_button.classList.remove('enable');
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
